import { ImportSetAdminTranslation } from 'app/area/import-sets-administration/constants';
import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { languageValidationParameter } from '../constants';
import { ImportSetItem, ImportSetItemValidation } from '../types-store';
import { ImportSetFormIds } from 'app/area/import-sets-administration/form/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ImportSetActionType } from 'app/area/import-sets-administration/form/types';

const validationMessageHelper = (propName: string, messages: ValidationMessage | ValidationMessage[]) => {
  return {
    [propName]: {
      level: ValidationLevel.error,
      messages
    }
  };
};

export const validateImportSet = (
  actionType: ImportSetActionType,
  importSet: ImportSetItem,
  languageOptions: ComplexValue<number>[],
  translation: ImportSetAdminTranslation
): ImportSetItemValidation => {

  const defaultValidationError = {
    level: ValidationLevel.error,
    message: translation.must_be_filled_out
  };

  const allLanguages = (languageOptions || [])
    .map(option => (importSet && importSet.language || [])
      .find(language => language.value === option.value)
      || { value: option.value }
    );

  const languageValidation = allLanguages
    .map(language =>
      language.description === undefined || language.description.trim() === ''
        ? {
          ...defaultValidationError,
          parameters: {
            [languageValidationParameter]: language.value
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const importDatabaseIdValidation = !isDefinedIncludingZero(importSet?.importDatabaseId)
    ? defaultValidationError
    : undefined;

  return {
    ...(languageValidation.length > 0 && validationMessageHelper(ImportSetFormIds.language, languageValidation)),
    ...(actionType === ImportSetActionType.edit && !!importDatabaseIdValidation && validationMessageHelper(ImportSetFormIds.importDatabaseId, [importDatabaseIdValidation]))
  };
};
